/* Base translations · Head folders — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): headFolders. */
export const I18N_BASE_HEAD_FOLDERS = {
  en: {
    headFolders: {
      selectEng: "Pick an engagement from the top selector to view its head folders.",
      autoGenTitle: "Auto-generated head folders",
      showVoided: "Show voided",
      voidedBadge: "voided",
      vouch: {
        title: "Vouching sheet(s)", filtered: "filtered to {fs}", none: "No vouching sheet yet for {fs}", create: "Create vouching sheet",
        link: "Link existing", pickExisting: "Pick an existing sheet…", linked: "Sheet linked to this folder", back: "Back", sheet: "Sheet",
        method: "Method", items: "Items", tested: "Tested", updated: "Updated", open: "Open",
      },
      del: {
        btn: "Delete", title: "Delete item", body: "\"{name}\" will move to the Recycle Bin for 30 days. You can restore it from there.",
        slotBody: "The slot {ref} and its content will move to the Recycle Bin for 30 days. The reference stays reserved and is not re-used.",
        unlink: "Remove link from this folder", deleteForm: "Delete the form", confirm: "Move to Recycle Bin", cancel: "Cancel",
        done: "Moved to the Recycle Bin", unlinked: "Link removed from this folder", locked: "Engagement is signed off — nothing can be deleted.",
        partnerOnly: "Signed-off items can only be deleted by the Partner", linkedWarn: "Also linked elsewhere — these links will be affected:",
      },
      filesSuffix: "files",
      filesSuffixOne: "file",
      emptyMapping: "No head folders yet — run the FS Mapping so each COA account carries an FSLI code, then refresh this page.",
      unassigned: "Unassigned head",
      unassignedHint: "Working papers filed here belong to COA accounts that don't yet carry an FSLI code.",
      refresh: "Refresh",
      addFromLibrary: "Add from library",
      // C3a · items 10, 11, 15 — head library + N/A + list-view labels.
      addHeadFromLibrary: "Add head from library",
      addHeadFromLibraryTitle: "Add head from library",
      addHeadFromLibraryDesc: "Pick an FS head from the 80-head IFRS taxonomy. Heads already on this engagement are disabled. Every addition is logged in the audit trail (W13).",
      searchPlaceholder: "Search by code or name…",
      libraryEmpty: "No FS heads match your search.",
      addBtn: "Add",
      addedOk: "Head {code} added.",
      alreadyPresent: "Already present",
      addFailed: "Could not add head",
      addedBadge: "Added",
      markNa: "Mark N/A",
      markNaReasonPrompt: "Reason for marking this head N/A (required, logged, cannot be deleted):",
      markedNaOk: "Head marked N/A.",
      formsEmptyHint: "No forms or worksheets pinned here yet \u2014 use the \"Add worksheet\" button below.",
      formsListTitle: "Forms & worksheets",
      indexListTitle: "Index",
      addWorksheetConfirm: "Create a new {type} worksheet for {head}? There are already {n} on this head.",
      leadReady: "Ready",
      // Batch 27 · F (M36)
      scopingNotDecided: "Scoping not decided",
      scopingBanner: "{n} heads have no scoping decision —",
      scopingBannerOne: "1 head has no scoping decision —",
      scopingLink: "Scoping",
      downloadTemplate: "Download template",
      zeroRows: "The uploaded file has 0 recognised rows. Check that it matches the expected template (download it with the button next to Choose file) and re-upload.",
      zeroRowsMissingCols: "Missing required columns: {cols}. Download the template to see every expected column.",
      hasBalanceTooltip: "Head has a balance — use Scoping (analytical review only)",
      naTitle: "N/A heads",
      naReasonLabel: "Reason",
      restore: "Restore",
      restoredOk: "Head restored.",
      standardFiles: {
        "01": "Procedures performed",
        "02": "Lead sheet",
        "03": "Sample link",
        "04": "Vouching sheet(s)",
        "05": "Observations",
        "06": "Forms / Worksheets",
        "07": "Cut-off test",
      },
    },
  },
  ar: {
    headFolders: {
      selectEng: "اختر مهمة من المحدد بالأعلى لعرض مجلداتها الرئيسية.",
      autoGenTitle: "مجلدات البنود المُنشأة تلقائيًا",
      showVoided: "عرض الملغاة",
      voidedBadge: "ملغى",
      filesSuffix: "ملفات",
      vouch: {
        title: "ورقة (أوراق) التوثيق", filtered: "مُصفّاة على {fs}", none: "لا توجد ورقة توثيق بعد للمجلد {fs}", create: "إنشاء ورقة توثيق",
        link: "ربط ورقة موجودة", pickExisting: "اختر ورقة موجودة…", linked: "تم ربط الورقة بهذا المجلد", back: "رجوع", sheet: "الورقة",
        method: "الطريقة", items: "البنود", tested: "المُختبَرة", updated: "آخر تحديث", open: "فتح",
      },
      del: {
        btn: "حذف", title: "حذف العنصر", body: "سيتم نقل \"{name}\" إلى سلة المحذوفات لمدة 30 يومًا. يمكنك استعادته من هناك.",
        slotBody: "سيتم نقل الخانة {ref} ومحتواها إلى سلة المحذوفات لمدة 30 يومًا. يبقى المرجع محجوزًا ولا يُعاد استخدامه.",
        unlink: "إزالة الربط من هذا المجلد", deleteForm: "حذف النموذج", confirm: "نقل إلى سلة المحذوفات", cancel: "إلغاء",
        done: "تم النقل إلى سلة المحذوفات", unlinked: "تمت إزالة الربط من هذا المجلد", locked: "تم توقيع المهمة — لا يمكن حذف أي شيء.",
        partnerOnly: "العناصر الموقّعة لا يحذفها إلا الشريك", linkedWarn: "مرتبط أيضًا في مواضع أخرى — ستتأثر هذه الروابط:",
      },
      filesSuffixOne: "ملف",
      emptyMapping: "لا توجد مجلدات بنود بعد — قم بتشغيل تعيين القوائم المالية بحيث يحمل كل حساب رمز FSLI، ثم قم بتحديث هذه الصفحة.",
      unassigned: "بند غير مخصص",
      unassignedHint: "أوراق العمل المحفوظة هنا تخص حسابات القوائم التي لم تحصل بعد على رمز FSLI.",
      refresh: "تحديث",
      addFromLibrary: "إضافة من المكتبة",
      // C3a · items 10, 11, 15 — head library + N/A + list-view labels (AR).
      addHeadFromLibrary: "إضافة بند من المكتبة",
      addHeadFromLibraryTitle: "إضافة بند من المكتبة",
      addHeadFromLibraryDesc: "اختر بندًا من قائمة بنود المعايير الدولية (\u206680\u2069 بندًا). البنود الموجودة مسبقًا في الارتباط معطَّلة. كل إضافة مُسجَّلة في سجل المراجعة (\u2066W13\u2069).",
      searchPlaceholder: "ابحث بالكود أو الاسم…",
      libraryEmpty: "لا يوجد بند مطابق للبحث.",
      addBtn: "إضافة",
      addedOk: "تمت إضافة البند \u2068{code}\u2069.",
      alreadyPresent: "موجود مسبقًا",
      addFailed: "تعذّرت إضافة البند",
      addedBadge: "مُضاف",
      markNa: "غير مُطبَّق",
      markNaReasonPrompt: "سبب اعتبار هذا البند غير مُطبَّق (إلزامي، يُسجَّل، لا يمكن حذفه):",
      markedNaOk: "تم اعتبار البند غير مُطبَّق.",
      formsEmptyHint: "لا توجد نماذج أو أوراق عمل مثبّتة هنا بعد \u2014 استخدم زر \"إضافة ورقة عمل\" أدناه.",
      formsListTitle: "النماذج وأوراق العمل",
      indexListTitle: "الفهرس",
      addWorksheetConfirm: "إنشاء ورقة عمل \u2066{type}\u2069 جديدة لـ \u2066{head}\u2069؟ يوجد بالفعل \u2066{n}\u2069 على هذا البند.",
      leadReady: "جاهز",
      // Batch 27 · F (M36)
      scopingNotDecided: "لم يُحدَّد النطاق",
      scopingBanner: "{n} بنود بلا قرار نطاق —",
      scopingBannerOne: "بند واحد بلا قرار نطاق —",
      scopingLink: "النطاق",
      downloadTemplate: "تنزيل القالب",
      zeroRows: "الملف المرفوع لا يحتوي على صفوف صالحة. تحقّق من مطابقته للقالب المتوقّع (قم بتنزيله بالزر بجوار اختيار الملف) ثم أعد الرفع.",
      zeroRowsMissingCols: "الأعمدة المطلوبة المفقودة: {cols}. نزّل القالب لمعرفة الأعمدة المتوقعة بالكامل.",
      hasBalanceTooltip: "للبند رصيد — استخدم النطاق (مراجعة تحليلية فقط)",
      naTitle: "بنود غير مُطبَّقة",
      naReasonLabel: "السبب",
      restore: "استعادة",
      restoredOk: "تمت استعادة البند.",
      standardFiles: {
        "01": "الإجراءات المنفذة",
        "02": "الورقة الرئيسية",
        "03": "رابط العينة",
        "04": "أوراق التدقيق المستندي",
        "05": "الملاحظات",
        "06": "النماذج / أوراق العمل",
        "07": "اختبار فصل الفترات",
      },
    },
  },
};

export default I18N_BASE_HEAD_FOLDERS;
